import React from "react";
import { useNavigate } from "react-router-dom";

export default function BrandStorySection() {
    const navigate=useNavigate()
  return (
    <section className="brand-story-section">
      <div className="brand-story-container">
        {/* Left Text Column */}
        <div className="brand-story-text">
          <h2 className="brand-story-title">
            Reserved for <span>special occasions</span>
          </h2>

          <p>
               At <strong>Vanathara</strong>, we believe every creation should be as soulful as it is beautiful. 
      Our collections bring together timeless tradition and conscious craftsmanship—because what you choose 
      should reflect care, culture, and connection.
          </p>

          <p>
           Products labelled as <strong>Committed</strong> are made using sustainable materials 
      and traditional processes that honor both people and the planet.
          </p>

          <p>
             Born in the heart of <strong>Wayanad</strong> — crafted for moments that matter.
          </p>

          <button className="brand-story-btn"    onClick={() => navigate("/about")}>Discover Our Story</button>
        </div>

        {/* Right Image Column */}
        <div className="brand-story-image">
          <img
            src="https://static.toiimg.com/thumb/msid-114818958,width-748,height-499,resizemode=4,imgsize-133614/6-Indian-towns-known-globally-for-their-handicrafts.jpg"
            alt="Brand Visual"
          />
        </div>
      </div>

      {/* Inline CSS styles */}
      <style>{`
        .brand-story-section {
          background: linear-gradient(180deg, #fff 0%, #f9f9f9 100%);
          padding: 80px 20px;
          font-family: 'Poppins', sans-serif;
        }

        .brand-story-container {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          justify-content: space-between;
          max-width: 1200px;
          margin: 0 auto;
          gap: 40px;
        }

        .brand-story-text {
          flex: 1 1 55%;
          color: #444;
          animation: fadeInLeft 1s ease;
        }

        .brand-story-title {
          font-size: 2.5rem;
          font-weight: 700;
          color: #111;
          margin-bottom: 25px;
          line-height: 1.2;
        }

        .brand-story-title span {
          background: linear-gradient(90deg, #c45493, #7b0046);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        .brand-story-text p {
          font-size: 1rem;
          line-height: 1.6;
          margin-bottom: 15px;
        }

        .brand-story-btn {
          background: #1c3f1d;
          color: #fff;
          border: none;
          padding: 12px 28px;
          border-radius: 50px;
          cursor: pointer;
          font-weight: 500;
          transition: all 0.3s ease;
        }

        .brand-story-btn:hover {
          background: #7b0046;
          transform: translateY(-3px);
        }

        .brand-story-image {
          flex: 1 1 40%;
          display: flex;
          justify-content: center;
          align-items: center;
          animation: fadeInRight 1s ease;
        }

        .brand-story-image img {
          width: 100%;
          max-width: 420px;
          border-radius: 20px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.15);
          transition: transform 0.4s ease;
        }

        .brand-story-image img:hover {
          transform: scale(1.03);
        }

        /* Animations */
        @keyframes fadeInLeft {
          from { opacity: 0; transform: translateX(-40px); }
          to { opacity: 1; transform: translateX(0); }
        }

        @keyframes fadeInRight {
          from { opacity: 0; transform: translateX(40px); }
          to { opacity: 1; transform: translateX(0); }
        }

        /* Responsive */
        @media (max-width: 768px) {
          .brand-story-container {
            flex-direction: column;
            text-align: center;
          }

          .brand-story-text, .brand-story-image {
            flex: 1 1 100%;
          }

          .brand-story-title {
            font-size: 2rem;
          }

          .brand-story-image img {
            max-width: 320px;
          }
        }
      `}</style>
    </section>
  );
}
